import { render, staticRenderFns } from "./KorrupsiyagaQarshi.vue?vue&type=template&id=8c0b3db2&scoped=true&"
import script from "./KorrupsiyagaQarshi.vue?vue&type=script&lang=js&"
export * from "./KorrupsiyagaQarshi.vue?vue&type=script&lang=js&"
import style0 from "./KorrupsiyagaQarshi.vue?vue&type=style&index=0&id=8c0b3db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0b3db2",
  null
  
)

export default component.exports